<template>
  <div transition="fade-transition">
    <v-snackbar
    :timeout="timeout"
    :bottom="y === 'bottom'"
    :top="y === 'top'"
    :left="x === 'left'"
    :right="x === 'right'"
    :multi-line = "multiLine"
    :absolute=absolute
    :light=light
    v-model="active"
    class="vts"
    role="alert"
    @click="dismiss"
  >
      <div class="vts_layout">
          <v-icon left v-if="!!icon" class="vts__icon" :color="iconColor">
            {{ icon }}
          </v-icon>

          <div class="vts_wrapper">
      <div class="vts__message" :class="{ 'vts__message--padded': showClose && !closeText }">
        <div id="vts_html_message" v-html="message"></div>
        <slot></slot>
      </div>

      <div class="vts_error_details">
        <v-card
          :hover="false"
          :outlined="true"
          max-width="544px"
          max-height="600px"
          class="py-2"
          @click.native="errorDetailsExpand = !errorDetailsExpand"
        >
          <v-card-title class="py-0 pr-2 vts_title_uppercase">
            error details...
          </v-card-title>
          <v-expand-transition>
            <div v-if="errorDetailsExpand">
              <v-card-text class="pt-2 pb-2" style="padding-bottom: 0; padding-top: 0;">
                <v-textarea
                  no-resize
                  rows="5"
                  readonly=true
                  :value="errorDetails"
                  class="padding_top_0"
                ></v-textarea>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </div>

      <div class="vts_report_error">
        <a href="javascript:void(0);" id="vts_feedback">REPORT ERROR</a>
      </div>
    </div>

          <v-btn
            :icon="!closeText"
            :text="!!closeText"
            class="vts__close"
            :class="{ 'vts__close--icon': !closeText }"
            :color="closeColor"
            v-if="showClose"
            @click="close"
          >
            <v-icon v-if="!closeText">{{ closeIcon }}</v-icon>
            <span v-if="!!closeText">{{ closeText }}</span>
          </v-btn>
      </div>
  </v-snackbar>
  </div>
</template>

<script>
  export default {
    name:'toastAlert',
    props: {
      x: {
        type: String,
        default: 'right'
      },
      y: {
        type: String,
        default: 'bottom'
      },
      color: {
        type: String,
        default: 'info'
      },
      icon: {
        type: String,
        default: ''
      },
      iconColor: {
        type: String,
        default: ''
      },
      classes: {
        type: [ String, Object, Array ],
        default: ''
      },
      message: {
        type: String,
        default: ''
      },
      errorDetails: {
        type: String,
        default: ''
      },
      timeout: {
        type: Number,
        default: 3000
      },
      dismissable: {
        type: Boolean,
        default: true
      },
      multiLine: {
        type: Boolean,
        default: false
      },
      vertical: {
        type: Boolean,
        default: false
      },
      showClose: {
        type: Boolean,
        default: false
      },
      closeText: {
        type: String,
        default: ''
      },
      closeIcon: {
        type: String,
        default: 'cancel'
      },
      closeColor: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      absolute: true,
      light: true,
      active: false,
      errorDetailsExpand: false,
    }),
    mounted() {
      this.$nextTick(() => this.show())
    },
    watch: {
      active: function (isActive, wasActive) {
        this.$emit('statusChange', isActive, wasActive)
      }
    },
    methods: {
      show() {
        this.active = true
      },

      close() {
        this.active = false
      },
      dismiss() {
        if (this.dismissable) {
          this.close()
        }
      },
    }
  }
</script>

<style scoped>
  div.v-snack--absolute.vts {
    z-index:10000;
  }

  .vts div.v-snack__wrapper.error {
    background-color: #FFFFFF !important;
    border-color: #B81237 !important;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 3px 5px !important;
  }

  .vts {
    max-width: none !important;
    width: auto !important;
    font-size: 16px !important;
    font-family: "Roboto", sans-serif !important;
    line-height: 1.5 !important;
  }

  .vts_layout {
    display: flex;
  }

  .vts_title_uppercase {
    font-size: 16px !important;
    text-transform: uppercase!important;
  }

  .vts_wrapper {
    display: grid;
    grid-row-gap: 1em;
  }

  .vts_report_error > a{
    color: #B81237 !important;
    text-align: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  .vts_report_error > a:link{
    text-decoration: none;
  }

  .vts_report_error > a:visited{
    text-decoration: none;
  }

  .vts .v-snack__content {
    justify-content: flex-start;
  }

  .vts__icon {
    margin-right: 12px;
    color: #B81237 !important;
    font-size: 32px !important;
  }

  .vts__message {
    margin-right: auto;
    color: #041E42 !important;
  }

  .vts__close {
    margin: 0 -8px 0 24px !important;
    justify-self: flex-end;
    /*color: #B81237 !important;*/
    color: #6D7079 !important;
  }

  .vts.v-snack--vertical .vts__icon {
    margin: 0 0 12px !important;
  }

  .vts.v-snack--vertical .v-snack__content {
    padding-bottom: 16px !important;
  }

  .vts.v-snack--vertical .vts__message--padded {
    padding: 12px 0 0;
  }

  .vts.v-snack--vertical .vts__icon + .vts__message {
    padding-top: 0;
  }

  .vts.v-snack--vertical .vts__close {
    margin: 12px 0 -8px !important;
  }

  .vts.v-snack--vertical .vts__close--icon {
    margin: 0 !important;
    position: absolute;
    right: 4px;
    top: 4px;
    transform: scale(0.75);
    padding: 4px !important;
  }

  .padding_top_0 {
    padding-top: 0;
  }
</style>
